import type { DeviceRow, SystemsResponse } from "shared-core/types/admin";
import { ref } from "vue";

export const devices = ref<DeviceRow[]>([]);
export const systemsData = ref<SystemsResponse>({
  integrations: [],
  catalog: [],
});

export function resetAdminState(): void {
  devices.value = [];
  systemsData.value = { integrations: [], catalog: [] };
}
